const lowerFirst = function (str: string): string {
  return str.charAt(0).toLowerCase() + str.substring(1);
};

export default lowerFirst;
